export const MIC_PERMISSION_DENIED = "MIC_PERMISSION_DENIED";

export function isMicPermissionDeniedError(error: unknown): boolean {
  if (error instanceof Error) {
    return (
      error.message === MIC_PERMISSION_DENIED ||
      error.name === "NotAllowedError" ||
      error.name === "PermissionDeniedError"
    );
  }
  return false;
}

export async function requestMicrophonePermission(): Promise<void> {
  if (!navigator.mediaDevices?.getUserMedia) {
    throw new Error(MIC_PERMISSION_DENIED);
  }

  let stream: MediaStream | null = null;

  try {
    stream = await navigator.mediaDevices.getUserMedia({
      audio: true,
      video: false,
    });
  } catch (error) {
    if (isMicPermissionDeniedError(error)) {
      throw new Error(MIC_PERMISSION_DENIED);
    }
    throw error;
  } finally {
    stream?.getTracks().forEach((track) => track.stop());
  }
}
